export default __webpack_public_path__ + "static/email.url-820d51eeebd0440f1bbfbef6d9f2c98c.svg";